import clsx from 'clsx'
import {ToolbarType, useLayout} from '../../core'
import {Toolbar} from './Toolbar'
import {PageTitleWrapper} from './page-title'
import {useThemeMode} from '../../../partials'
import {Box} from '@mui/material'

const ToolbarWrapper = () => {
  const {mode} = useThemeMode()

  const {config, classes} = useLayout()
  if (!config.app?.toolbar?.display) {
    return null
  }

  const isPageTitleVisible = showPageTitle(config.app?.toolbar?.layout, config.app?.pageTitle?.display)

  return (
    <Box
      component='div'
      id='kt_app_toolbar'
      sx={mode == 'dark' ? {backgroundColor: '#1a1a27'} : {}}
      //className={clsx('app-toolbar', classes.toolbar.join(' '), config?.app?.toolbar?.class)}
      className='p-3'
    >
      <Box
        component='div'
        id='kt_app_toolbar_container'
        className={clsx(
          'app-container',
          classes.toolbarContainer.join(' '),
          config.app?.toolbar?.containerClass,
          config.app?.toolbar?.minimize?.enabled ? 'app-toolbar-minimize' : '',
          {
            'container-fluid': config.app?.toolbar?.container === 'fluid',
            'container-xxl': config.app?.toolbar?.container === 'fixed',
          }
        )}
        sx={{px: '0px !important'}}
      >
        {/*{isPageTitleVisible && <PageTitleWrapper />}*/}
        <PageTitleWrapper />
        <Toolbar />
      </Box>
    </Box>
  )
}

const showPageTitle = (appToolbarLayout?: ToolbarType, appPageTitleDisplay?: boolean): boolean => {
  const viewsWithPageTitles = ['classic', 'reports', 'saas']
  if (!appToolbarLayout || !appPageTitleDisplay) {
    return false
  }

  return appPageTitleDisplay && viewsWithPageTitles.some((t) => t === appToolbarLayout)
}

export {ToolbarWrapper}
